import { apiClient } from '@devd-client/api';
import { CfrResponse, ReleaseResponse } from '../helpers/dora.types';
import { getToken, getOrgId } from '@devd-client/devd/auth';

export const getCfr = (): Promise<CfrResponse> =>
  apiClient(`/v1/dora/org/${getOrgId()}/cfr`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
  });

export const addUpdateCfr = (params: any): Promise<any> => {
  return apiClient(`/v1/dora/org/${getOrgId()}/cfr`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(params.cfrData),
  });
};

export const getCustomField = (): Promise<any> =>
  apiClient(`/v1/integration/org/${getOrgId()}/customFields`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
  });

export const getRelease = (): Promise<ReleaseResponse> =>
  apiClient(`/v1/dora/org/${getOrgId()}/release`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const addUpdateRelease = (params: any): Promise<any> => {
  return apiClient(`/v1/dora/org/${getOrgId()}/release`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(params.releaseData),
  });
};

export const getAllJiraProjects = (): Promise<any> =>
  apiClient(`/v1/integration/jira/org/${getOrgId()}/projects/lite`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });
